<template>
   <v-divider
        class="mx-4"
        :inset="false"
        vertical
      ></v-divider>
</template>

<script>
export default {
  name: 'MyFormDivider'
}

</script>

<style scoped>

</style>
